class TabsContainer extends HTMLElement {
  constructor() {
    super();
    this.tabs = null;
    this.panel = null;
    this.nativeGrid = null;
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('[data-ref="tab"]');
    this.panel = this.querySelector('[data-ref="tabs-panel"]');
    this.nativeGrid = document.querySelector('[id*="main"]') || document.querySelector('.collection__main, .collection-main, main-collection');

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        if (tab.classList.contains('active')) {
          this.#resetTabs();
          this.panel.innerHTML = '';
          if (this.nativeGrid) this.nativeGrid.style.display = '';
        } else {
          this.#resetTabs();
          this.#selectTab(tab);
          if (this.nativeGrid) this.nativeGrid.style.display = 'none';
        }
      });
    });
  }

  #selectTab(tab) {
    const template = tab.querySelector('template');
    if (template) {
      const tab_content = template.content.querySelector('[data-ref="tab-content"]');
      this.panel.innerHTML = tab_content.innerHTML;
    }
    tab.classList.add('active');
  }

  #resetTabs() {
    this.tabs.forEach((tab) => tab.classList.remove('active'));
    this.panel.innerHTML = '';
  }
}

if (!customElements.get('tabs-container')) {
  customElements.define('tabs-container', TabsContainer);
}
